import React, { useState, useEffect } from "react";
import { Breadcrumb, Image, Modal } from "antd";
import { CloseOutlined, DoubleRightOutlined } from "@ant-design/icons";
import Navbar from "../../components/Navbar/Navbar";
import { routes } from "../../Routes";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import UploadBillImage from "./uploadBillImage";
import { UserImageUpload } from "../../API  Functions/UserMangement";
import { updatePOImages } from "../../API  Functions/PurchaseFunctions";
import UsermanagementPopup from "../../Popups/usermanagementPopup";
import LoadingSpinner from "../../components/Loading";
import i18next from "i18next";
import { checkPermission } from "../../Utils/permissionHelper";
import JsBarcode from "jsbarcode";
import labelSample from "../../assets/35mm.png";
import labelSample2 from "../../assets/35mmx12mm.png";
import { toast } from "react-toastify";
import { URLS } from "../../API/API endpoints";
import axiosInstance from "../../AxiosInstance";

const PurchaseOrder = () => {
  const { t } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const company_id = useSelector((state) => state?.login?.user?.result?.company_id);
  const [noOrdersFound, setNoOrdersFound] = useState(false);
  const location = useLocation();
  const { orderData, from } = location.state || {};
  const data = orderData;

  console.log("from---->", from);

  const [base64Images, setBase64Images] = useState([]);
  const [addImage, setAddImage] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  const [popup, setpopup] = useState(false);
  const [message, setmessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(false);
  const [isFileValid, setFileValid] = useState(true);
  const isGinne = useSelector(
    (state) => state?.geneLoginReducer?.isGinneLogin
  );

  // --- Label printing state ---
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [showPriceModal, setShowPriceModal] = useState(false);
  const [isPrintMode, setIsPrintMode] = useState(false);
  // NEW: label size — "35x24" (name + optional price) or "35x12" (two barcodes per page)
  const [labelSize, setLabelSize] = useState("35x24");

  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelling, setCancelling] = useState(false);

  useEffect(() => {
    if (base64Images && isFileValid === false) {
      setBase64Images("");
    }
  }, [isFileValid, base64Images]);

  useEffect(() => {
    if (data?.order_details?.attached_image_urls?.length > 0) {
      setAddImage(true);
    }
  }, [data]);

  // --- Barcode SVG generator (supports size options) ---
  const generateBarcodeSVG = (value, options = {}) => {
    const svg = document.createElement("svg");
    JsBarcode(svg, value, {
      format: "CODE128",
      lineColor: "#000",
      height: options.height || 60,
      displayValue: options.displayValue !== undefined ? options.displayValue : true,
      fontSize: options.fontSize || 20,
      margin: 0,
       width: options.width || 1.5,
    });
    return svg.outerHTML;
  };

  // --- Print Labels: 35×24mm with name + optional price (existing) ---
  const handlePrintLabels35x24 = (isPrice) => {
    const labels = selectedProducts
      .map((item) => {
        const barcodeSVG = generateBarcodeSVG(item.barcode);
        return `
        <div class="label">
          <div class="product-name">${item.name}</div>
          ${barcodeSVG}
          ${isPrice
            ? `<div class="price">EGP ${item.price ? item.price.toFixed(2) : "0.00"}</div>`
            : ""
          }
        </div>
      `;
      })
      .join("");

    const htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8" />
      <title>Print Labels</title>
      <style>
        @page {
          size: 35mm 24mm;
          margin: 0;
        }
        body {
          padding: 0;
          font-family: Arial, sans-serif;
          margin: 0 auto;
        }
        .label {
          width: 35mm;
          height: 24mm;
          margin: 0 auto;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          text-align: center;
          padding: 1mm 1mm 1mm 2mm;
        }
        .label svg {
          width: 33mm;
          height: 10mm;
          display: block;
        }
        .product-name {
          font-size: 2.7mm;
          max-height: 9mm;
          overflow: hidden;
          margin-top: auto;
          margin-bottom: 3px;
        }
        .price {
          font-size: 3mm;
          margin-top: 3px;
        }
      </style>
    </head>
    <body>
      ${labels}
    </body>
    </html>
  `;

    const printWindow = window.open("", "_blank");
    printWindow.document.write(htmlContent);
    printWindow.document.close();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 300);
  };

  // --- Print Labels: 35×24mm two-barcode layout ---
  // Same page size as the existing label (35×24mm).
  // Two products' barcodes printed one after another on a single page.
  // No product name, no price.
 const handlePrintLabels35x12 = (isPrice) => {
  const pairs = [];
  for (let i = 0; i < selectedProducts.length; i += 2) {
    pairs.push([selectedProducts[i], selectedProducts[i + 1] || null]);
  }

const renderSlot = (item) => {
  if (!item) return "";
  const svg = item.barcode
    ? generateBarcodeSVG(item.barcode, { height: 28, displayValue: false, width: 1.2 })
    : `<div style="color:#999;font-size:2mm;text-align:center;">No Barcode</div>`;
  return `
    <table cellpadding="0" cellspacing="0" style="width:35mm;border-collapse:collapse;">
      <tr>
        <td style="width:2mm;"></td>
        <td style="width:31mm;text-align:center;vertical-align:middle;">
          <div class="barcode-wrap">${svg}</div>
          <div class="info-row">
            <span class="barcode-num">${item.barcode ?? ""}</span>
            ${isPrice ? `<span class="price">EGP ${item.price ?? "0"}</span>` : ""}
          </div>
        </td>
        <td style="width:2mm;"></td>
      </tr>
    </table>
  `;
};

  const pairHTML = pairs.map(([top, bottom]) => `
    <table class="page" cellpadding="0" cellspacing="0">
      <tr>
        <td class="slot">${renderSlot(top)}</td>
      </tr>
      <tr>
        <td class="divider-row"><div class="divider"></div></td>
      </tr>
      <tr>
        <td class="slot">${renderSlot(bottom)}</td>
      </tr>
    </table>
  `).join("");

  const htmlContent = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8" />
  <title>Print Labels</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }

    @page {
      size: 35mm 24mm;
      margin: 0;
    }

    html, body {
      width: 35mm;
      margin: 0;
      padding: 0;
      font-family: Arial, sans-serif;
    }

    .page {
      width: 35mm;
      height: 24mm;
      page-break-after: always;
      border-collapse: collapse;
      table-layout: fixed;
      overflow: hidden;
    }

    .slot {
      width: 35mm;
      height: 11mm;
      text-align: center;
      vertical-align: middle;
      padding: 0.3mm 0;
      overflow: hidden;
    }

    /* Fixed barcode container — always same height regardless of barcode length */
    .barcode-wrap {
      width: 31mm;
      height: 7mm;
      overflow: hidden;
      margin: 0 auto;
      flex-shrink: 0;
    }

    .barcode-wrap svg {
      display: block !important;
       max-width: 33mm !important;
      height: 7mm !important;
      margin: 0 auto !important;
    }

    /* Number on left, price on right — same line */
    .info-row {
      width: 33mm;
      margin: 0.4mm auto 0;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      line-height: 1;
    }

    .barcode-num {
      font-size: 2mm;
      color: #333;
      text-align: left;
    }

    .price {
    font-size: 2mm;
      color: #333;
      text-align: right;
    }

    .divider-row {
      height: 2mm;
      padding: 0;
      vertical-align: middle;
    }

    .divider {
      width: 30mm;
      height: 0.3mm;
      background: #ccc;
      margin: 0 auto;
    }
  </style>
</head>
<body>
  ${pairHTML}
</body>
</html>`;

  const printWindow = window.open("", "_blank");
  printWindow.document.write(htmlContent);
  printWindow.document.close();
  setTimeout(() => { printWindow.print(); printWindow.close(); }, 300);
};



  // Unified dispatcher
  const handlePrintLabels = (isPrice) => {
    if (labelSize === "35x12") {
      handlePrintLabels35x12(isPrice);
    } else {
      handlePrintLabels35x24(isPrice);
    }
  };

  const toggleSelectProduct = (product) => {
    setSelectedProducts((prev) => {
      const exists = prev.find((p) => p.barcode === product.barcode);
      if (exists) {
        return prev.filter((p) => p.barcode !== product.barcode);
      }
      return [...prev, product];
    });
  };

  const handleExitPrintMode = () => {
    setIsPrintMode(false);
    setSelectedProducts([]);
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      const allProducts = data.lines.map((product) => ({
        barcode: product.barcode,
        name: product.product_name,
        price: product.sale_price,
      }));
      setSelectedProducts(allProducts);
    } else {
      setSelectedProducts([]);
    }
  };

  const handleAttachImages = async () => {
    if (!checkPermission("/purchase/list", isGinne)) {
      return;
    }

    setProcessing(true);
    if (base64Images.length > 0) {
      try {
        const uploadedUrls = [];

        const existingImagesCount =
          data?.order_details?.attached_image_urls?.length || 0;

        for (let i = 0; i < base64Images.length; i++) {
          const imageName = `${data?.order_details.order_id}-${String(
            existingImagesCount + i + 1
          ).padStart(2, "0")}`;

          const imageResponse = await UserImageUpload(
            base64Images[i],
            imageName
          );

          if (imageResponse) {
            console.log(`Image ${i + 1} uploaded successfully`);
            uploadedUrls.push(imageResponse);
          } else {
            console.error(`Error uploading image ${i + 1}:`, imageResponse);
          }
        }

        if (uploadedUrls.length > 0) {
          setImageUrls(uploadedUrls);
          const poId = data?.order_details?.order_id;

          const payload = {
            po_id: poId,
            image_urls: uploadedUrls,
          };
          const UploadRes = await updatePOImages(payload);
          if (UploadRes?.result?.status_code === 200) {
            console.log("updated successfully", UploadRes);
            setmessage("Image Uploaded Successfully");
            setProcessing(false);
            setIsSuccess(true);
            setpopup(true);
          } else {
            console.error("Error uploading image", UploadRes);
            setProcessing(false);
          }
        }

        setBase64Images([]);
      } catch (error) {
        console.error("Error during image upload:", error);
        setProcessing(false);
      }
    } else {
      console.log("No images to upload");
      setProcessing(false);
    }
  };

  const handleCancel = () => {
    setBase64Images([]);
  };

  const handleRemoveImage = (index) => {
    setBase64Images((prev) => prev.filter((_, i) => i !== index));
  };

  const handleClose = () => {
    setpopup(false);
    setIsSuccess(false);
    navigate(routes.purchase.purchaseList);
  };

  const allSelected =
    data?.lines?.length > 0 &&
    data.lines.every((product) =>
      selectedProducts.some((p) => p.barcode === product.barcode)
    );

  const handleCancelOrder = async () => {
    setCancelling(true);
    try {
      const response = await axiosInstance.post(URLS.CANCEL_ORDER, {
        order_id: data?.order_details?.order_id,
        company_id: company_id
      });
      if (response?.data?.result?.status_code == 200) {
        setShowCancelModal(false);
        toast.success(t("Order Cancelled Successfully"));
        navigate(routes.purchase.purchaseList);
      } else {
        toast.error(t(response?.data?.result?.status));
      }
    } catch (error) {
      console.error("Error cancelling order:", error);
    } finally {
      setCancelling(false);
    }
  };

  return (
    <>
      {processing && <LoadingSpinner />}

      {/* ── Print Label Modal ── */}
      {showPriceModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl p-8 w-[520px] shadow-2xl text-center relative">
            <button
              className="absolute top-3 right-3 text-gray-600 hover:text-black text-2xl"
              onClick={() => setShowPriceModal(false)}
            >
              ×
            </button>

            {/* Label size sample image */}
            <div className="flex justify-center mb-4">
              {labelSize === "35x24" ?
                <img
                  src={labelSample}
                  alt="Label size example"
                  className="w-72 rounded-lg border"
                />
                :
                <img
                  src={labelSample2}
                  alt="Label size example"
                  className="w-72 rounded-lg border"
                />
              }
            </div>

            {/* Label size selector */}
            <div className="mb-5">
              <p className="text-sm text-gray-500 mb-2 font-medium">
                {t("Select Label Size")}
              </p>
              <div className="flex justify-center gap-4">
                {/* 35×24 option */}
                <button
                  onClick={() => setLabelSize("35x24")}
                  className={`flex flex-col items-center px-5 py-3 rounded-xl border-2 transition-all ${labelSize === "35x24"
                      ? "border-primaryBlue bg-blue-50 text-primaryBlue"
                      : "border-gray-200 text-gray-500 hover:border-gray-400"
                    }`}
                >
                  {/* Visual icon: taller rectangle */}
                  <div
                    className={`mb-1 rounded border-2 ${labelSize === "35x24" ? "border-primaryBlue" : "border-gray-400"
                      }`}
                    style={{ width: 40, height: 27 }}
                  />
                  <span className="text-xs font-semibold">35 × 24 mm</span>
                  <span className="text-[10px] text-gray-400 mt-0.5">
                    {t("Name + Barcode")}
                  </span>
                </button>

                {/* 35×12 option */}
                <button
                  onClick={() => setLabelSize("35x12")}
                  className={`flex flex-col items-center px-5 py-3 rounded-xl border-2 transition-all ${labelSize === "35x12"
                      ? "border-primaryBlue bg-blue-50 text-primaryBlue"
                      : "border-gray-200 text-gray-500 hover:border-gray-400"
                    }`}
                >
                  {/* Visual icon: single narrow landscape rectangle */}
                  <div
                    className={`rounded border-2 mb-1 ${labelSize === "35x12" ? "border-primaryBlue" : "border-gray-400"
                      }`}
                    style={{ width: 40, height: 13 }}
                  />
                  <span className="text-xs font-semibold">35 × 12 mm</span>
                  <span className="text-[10px] text-gray-400 mt-0.5">
                    {t("Barcode Only")}
                  </span>
                </button>
              </div>
            </div>

            {/* Conditional bottom section */}
            {labelSize === "35x24" ? (
              // Existing flow: ask about price
              <>
                <p className="text-base text-gray-700 mb-4">
                  {t("Your labels are sized 35mm × 24mm as shown above.")}
                </p>
                <h2 className="text-xl font-semibold mb-6">
                  {t("Do you want to print product price also?")}
                </h2>
                <div className="flex justify-between mt-4">
                  <button
                    className="px-6 py-3 bg-gray-300 rounded-lg w-32 text-lg font-medium"
                    onClick={() => {
                      setShowPriceModal(false);
                      handlePrintLabels(false);
                      handleExitPrintMode();
                    }}
                  >
                    {t("No")}
                  </button>
                  <button
                    className="px-6 py-3 bg-primaryBlue text-white rounded-lg w-32 text-lg font-medium"
                    onClick={() => {
                      setShowPriceModal(false);
                      handlePrintLabels(true);
                      handleExitPrintMode();
                    }}
                  >
                    {t("Yes")}
                  </button>
                </div>
              </>
            ) : (
              // 35×12 flow: no price question, just print
              <>
                <p className="text-base text-gray-700 mb-4">
                  {t("Two barcodes printed per 35×24mm label.")}
                </p>
                <h2 className="text-xl font-semibold mb-6">
                  {t("Do you want to print product price also?")}
                </h2>
                <div className="flex justify-between mt-4">
                  <button
                    className="px-6 py-3 bg-gray-300 rounded-lg w-32 text-lg font-medium"
                    onClick={() => {
                      setShowPriceModal(false);
                      handlePrintLabels(true); // Without price
                    }}
                  >
                    {t("No")}
                  </button>
                  <button
                    className="px-6 py-3 bg-primaryBlue text-white rounded-lg w-32 text-lg font-medium"
                    onClick={() => {
                      setShowPriceModal(false);
                      handlePrintLabels(true); // With price
                    }}
                  >
                    {t("Yes")}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      <div className="flex">
        <div className="flex flex-col bg-[#F6F7F9] min-h-[93vh] min-w-full flex-1">
          <Navbar heading="Purchase History" />
          <div className="ms-2 me-2 font-extrabold sm:ms-3 sm:me-4">
            <Breadcrumb
              separator={<DoubleRightOutlined />}
              items={[
                {
                  title: (<Link
                    to={
                      routes.purchase.supplyPayment
                    }
                  >
                    {t("Vendor Invoices")}
                  </Link>

                  ),
                  key: "purchaseOrder",
                },
                { title: `${data?.order_details?.order_no}` },
              ]}
              className="relative mt-3"
            />
            {data?.order_details?.status === "done" && (
              <div className="flex justify-end mt-2">
                <button
                  onClick={() => setShowCancelModal(true)}
                  className="px-4 py-2 bg-[#FF1616] hover:bg-[#e01414] text-white text-sm font-semibold rounded-lg"
                >
                  {t("Cancel Order")}
                </button>
              </div>
            )}
            {data?.order_details?.status == 'cancel' &&
              <div className="flex justify-end mt-2">
                <div className="px-4 py-2 bg-[#ffd1d1] text-[#ef3a3a] text-sm font-semibold rounded-lg">
                  {t("Cancelled")}
                </div>
              </div>
            }

            {/* Attached images section */}
            <h3 className="text-l mt-2 font-semibold text-[#272728]">
              {t("Attached Bill Images")}
            </h3>
            <div className="mt-2 min-w-full overflow-hidden rounded-lg border-2 border-dashed border-[#C6C6C6] bg-white">
              <div className="ms-2 me-2">
                {data?.order_details?.attached_image_urls?.length > 0 ? (
                  <div className="mt-4 pb-2 min-w-full">
                    <div className="flex space-x-4 overflow-x-auto scrollbar-thin overflow-hidden">
                      {data?.order_details?.attached_image_urls.map(
                        (image, index) => (
                          <div
                            key={index}
                            className="flex-none w-[120px] h-[120px] rounded-lg shadow-md overflow-hidden"
                          >
                            <Image
                              src={image}
                              alt={`Bill${index + 1}`}
                              className="w-full h-full object-cover"
                            />
                          </div>
                        )
                      )}
                    </div>
                  </div>
                ) : (
                  <p className="mt-4 text-center text-gray-600">
                    {t("No Bill Images Attached")}
                  </p>
                )}
                {data?.order_details?.status != 'cancel' ? <>
                  <div className="mt-4">
                    <UploadBillImage
                      foldername={"store_app_UAT"}
                      onfileAdd={`storeuserurl`}
                      setBase64Images={(images) => {
                        setBase64Images((prev) => [...prev, images]);
                      }}
                      imageurl={addImage}
                      setFileValid={setFileValid}
                    />
                  </div>
                  <div className="flex flex-row justify-center font-medium mt-1 mb-4">
                    <span className="text-center text-xs text-[#999999]">
                      png, jpg, jpeg
                    </span>
                    <span className="ms-1 text-center text-xs text-[#999999]">
                      (max 5mb)
                    </span>
                  </div>
                </> : <div className="mb-4"></div>}

                {base64Images.length > 0 && (
                  <>
                    <div className="mt-4">
                      <h4 className="font-normal mb-2 italic text-gray-600">
                        {t("Selected Images")}
                      </h4>
                      <div className="flex space-x-4 overflow-x-auto">
                        {base64Images.map((image, index) => (
                          <div
                            key={index}
                            className="relative flex-none w-[120px] h-[120px] rounded-lg shadow-md overflow-hidden"
                          >
                            <Image
                              src={image}
                              alt={`Uploaded Image ${index + 1}`}
                              className="w-full h-full object-cover"
                            />
                            <button
                              onClick={() => handleRemoveImage(index)}
                              className="absolute top-0 right-0 text-black p-0 rounded-full"
                              style={{ zIndex: 10 }}
                            >
                              <CloseOutlined />
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Save and Cancel buttons */}
                    <div className="mb-4 mt-4 flex flex-col justify-end gap-2 sm:flex-row">
                      <button
                        onClick={handleCancel}
                        className="w-full rounded-lg border border-primaryBlue bg-white px-4 py-2 text-primaryBlue hover:bg-red-600 sm:w-auto"
                      >
                        {t("Cancel")}
                      </button>
                      <button
                        onClick={handleAttachImages}
                        disabled={processing}
                        className="w-full rounded-lg bg-primaryBlue px-4 py-2 text-white hover:bg-primaryBlue sm:w-auto"
                      >
                        {t("Save")}
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Table header row: title + Print Labels button */}
            <div className="flex items-center justify-between mt-6 mb-2">
              <h3 className="text-sm font-semibold text-[#272728]">
                {t("Order Items")}
              </h3>

              {!isPrintMode ? (
                <button
                  onClick={() => setIsPrintMode(true)}
                  className="flex items-center gap-1.5 px-3 h-8 bg-[#7EC242] text-white text-sm font-semibold rounded-lg"
                >
                  🖨 {t("Print Labels")}
                </button>
              ) : (
                <div className="flex items-center gap-2">
                  <span className="text-sm text-gray-500 italic">
                    {selectedProducts.length > 0
                      ? `${selectedProducts.length} ${t("product(s) selected")}`
                      : t("Select products to print")}
                  </span>
                  <button
                    onClick={handleExitPrintMode}
                    className="px-3 h-8 bg-white border border-gray-300 text-gray-600 text-sm font-medium rounded-lg"
                  >
                    {t("Cancel")}
                  </button>
                  <button
                    disabled={selectedProducts.length === 0}
                    onClick={() => setShowPriceModal(true)}
                    className={`flex items-center gap-1.5 px-3 h-8 text-white text-sm font-semibold rounded-lg transition-opacity ${selectedProducts.length === 0
                        ? "bg-[#7EC242] opacity-40 cursor-not-allowed"
                        : "bg-[#7EC242]"
                      }`}
                  >
                    🖨 {t("Print Selected")}
                    {selectedProducts.length > 0 && (
                      <span className="bg-white text-[#7EC242] text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                        {selectedProducts.length}
                      </span>
                    )}
                  </button>
                </div>
              )}
            </div>

            {/* Selection mode hint banner */}
            {isPrintMode && (
              <div className="mb-3 px-4 py-2 bg-[#f0fbe6] border border-[#7EC242] rounded-lg text-sm text-[#4a7c1f] flex items-center gap-2">
                <span>✅</span>
                <span>{t("Check the products you want to print labels for, then click Print Selected.")}</span>
              </div>
            )}

            {/* Purchase Order Table */}
            <div className="mb-6">
              <table className="min-w-full bg-white rounded-lg border-collapse">
                <thead className="bg-[#D1F1FC] rounded-lg">
                  <tr>
                    {isPrintMode && (
                      <th
                        className={`py-3 px-4 text-start text-sm font-semibold text-[#272728] ${i18next.language === "ar"
                            ? "rounded-tr-lg"
                            : "rounded-tl-lg"
                          }`}
                      >
                        <input
                          type="checkbox"
                          checked={allSelected}
                          onChange={(e) => handleSelectAll(e.target.checked)}
                        />
                      </th>
                    )}
                    <th
                      className={`py-3 px-4 text-start text-sm font-semibold text-[#272728] ${!isPrintMode
                          ? i18next.language === "ar"
                            ? "rounded-tr-lg"
                            : "rounded-tl-lg"
                          : ""
                        }`}
                    >
                      {t("Product Name")}
                    </th>
                    <th className="py-3 px-4 text-start text-sm font-semibold text-[#272728]">
                      {t("UOM")}
                    </th>
                    <th className="py-3 px-4 text-start text-sm font-semibold text-[#272728]">
                      {t("Quantity")}
                    </th>
                    <th className="py-3 px-4 text-start text-sm font-semibold text-[#272728]">
                      {t("Cost Price")}
                    </th>
                    <th className="py-3 px-4 text-start text-sm font-semibold text-[#272728]">
                      {t("Sales Price")}
                    </th>
                    <th
                      className={`py-3 px-4 text-start text-sm font-semibold text-[#272728] ${i18next.language === "ar"
                          ? "rounded-tl-lg"
                          : "rounded-tr-lg"
                        }`}
                    >
                      {t("Total")}
                    </th>
                  </tr>
                </thead>
                <tbody className="rounded-b-lg">
                  {data.lines.map((product, index) => {
                    const isSelected = selectedProducts.some(
                      (p) => p.barcode === product.barcode
                    );
                    return (
                      <tr
                        key={index}
                        className={`border-t transition-colors ${isPrintMode && isSelected
                            ? "bg-[#f0fbe6]"
                            : index % 2 === 0
                              ? "bg-white"
                              : "bg-[#f9f9f9]"
                          } ${isPrintMode ? "cursor-pointer hover:bg-[#f0fbe6]" : ""}`}
                        onClick={() => {
                          if (isPrintMode)
                            toggleSelectProduct({
                              barcode: product.barcode,
                              name: product.product_name,
                              price: product.sale_price,
                            });
                        }}
                      >
                        {isPrintMode && (
                          <td className="py-3 px-4">
                            <input
                              type="checkbox"
                              checked={isSelected}
                              onChange={() =>
                                toggleSelectProduct({
                                  barcode: product.barcode,
                                  name: product.product_name,
                                  price: product.sale_price,
                                })
                              }
                              onClick={(e) => e.stopPropagation()}
                            />
                          </td>
                        )}

                        <td
                          className={`py-3 px-4 font-normal text-sm text-[#272728] flex items-center ${i18next.language === "ar"
                              ? "rounded-r-lg"
                              : "rounded-l-lg"
                            }`}
                        >
                          <img
                            className="w-12 h-12 object-contain me-3"
                            src={product.image}
                            alt={product.product_name}
                          />
                          {product.product_name}
                        </td>

                        <td className="py-3 px-4 font-normal text-sm text-[#272728]">
                          {product.product_uom || "N/A"}
                        </td>

                        <td className="py-3 px-4 font-normal text-sm text-[#272728]">
                          {product.product_qty || "N/A"}
                        </td>

                        <td className="py-3 px-4 font-normal text-sm text-[#272728]">
                          EGP {product.cost_price?.toFixed(2) || "0.00"}
                        </td>

                        <td className="py-3 px-4 font-normal text-sm text-[#272728]">
                          EGP {product.sale_price?.toFixed(2) || "0.00"}
                        </td>

                        <td
                          className={`py-3 px-4 font-normal text-sm text-[#272728] ${i18next.language === "ar"
                              ? "rounded-l-lg"
                              : "rounded-r-lg"
                            }`}
                        >
                          EGP {product.sub_total?.toFixed(2) || "0.00"}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {popup && (
          <UsermanagementPopup
            isSuccess={isSuccess}
            message={message}
            close={() => {
              handleClose();
              if (message === t("User Updated Successfully"));
            }}
          />
        )}
      </div>

      <Modal
        open={showCancelModal}
        onCancel={() => setShowCancelModal(false)}
        footer={null}
        centered
        closable={false}
      >
        <div className="text-center p-6">
          <h3 className="text-lg font-semibold mb-4 text-gray-800">
            {t("Are you sure you want to cancel this order?")}
          </h3>
          <div className="flex justify-center gap-4 mt-6">
            <button
              onClick={() => setShowCancelModal(false)}
              className="px-6 py-2 rounded-lg border border-gray-300 hover:bg-gray-100 text-gray-700 font-semibold"
            >
              {t("No")}
            </button>
            <button
              onClick={handleCancelOrder}
              disabled={cancelling}
              className="px-6 py-2 rounded-lg bg-[#FF1616] hover:bg-[#e01414] text-white font-semibold"
            >
              {cancelling ? t("Cancelling...") : t("Yes")}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PurchaseOrder;